import React from 'react'
import './Navbar-style.css'
import logo from './protonity.png'

export default function Navbar() {
  return (
    <>

    <header>
        <img src={logo} alt="Protonity by Nitin" />
        <nav>
            <input type="checkbox" id="menubar"/>
                <label htmlFor="menubar">
                    <i>Menu</i>
                </label>
            <ul>                
                <li><a href="/" rel="noreferrer" target={'_blank'} className="active">Home</a></li>
                <li><a href="https://www.w3schools.com/html/default.asp" rel="noreferrer" target={'_blank'}>HTML</a></li>
                <li><a href="https://www.w3schools.com/css/default.asp" rel="noreferrer" target={'_blank'}>CSS</a></li>
                <li><a href="https://www.w3schools.com/js/default.asp" rel="noreferrer" target={'_blank'}>JavaScript</a></li>
                <li><a href="https://www.w3schools.com/react/default.asp" rel="noreferrer" target={'_blank'}>React</a></li>
                <li><a href="https://www.w3schools.com/nodejs/" rel="noreferrer" target={'_blank'}>NodeJS</a></li>
                <li><a href="https://www.instagram.com/nitinrathodofficial/" rel="noreferrer" target={'_blank'}>Join Us</a></li>
                <li><a href="https://www.facebook.com/nitin.rathod0173/" rel="noreferrer" target={'_blank'}>About</a></li>

            </ul>
        </nav>      
    </header>   
    
    </>
  );
}
